import { Link } from 'react-router-dom';
import '../styles/App.css';
import { FaInstagram } from 'react-icons/fa';
import React from "react";
import Menu from "./Menu";

const Header = () => {
  const menuItems = [
    { label: "Home", href: "/" },
    { label: "About", href: "/about" },
    { label: "Portfolio", href: "/portfolio" },
    { label: "Contact", href: "/contact" },
  ];

  return (
    <header className="bg-white">
      {/* Constrained inner wrapper keeps title + nav closer together on wide screens */}
      <div className="w-full max-w-5xl mx-auto flex items-center justify-between px-4 py-4">
        {/* Title */}
        <h1 className="text-3xl md:text-4xl font-playfair font-bold text-black">
          Melory Mirashrafi
        </h1>

        {/* Desktop nav (right side) */}
        <nav className="hidden md:flex items-center gap-8">
          {menuItems.map((item, idx) => (
            <a
              key={idx}
              href={item.href}
              className="text-black font-playfair font-medium hover:opacity-60 transition-opacity"
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* Mobile hamburger (right side) */}
        <div className="md:hidden">
          <Menu items={menuItems} />
        </div>
      </div>
    </header>
  );
};

export default Header;
